import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import { ButtonText, MicrosoftSignInAnchor } from './MicrosoftLoginButton.styles'; // @ts-expect-error not converted to TS

import Image from '../../images/imageUrls';
export const MicrosoftLoginButton = ({
  onClick,
  smartLogin
}) => {
  const isIFramed = useMemo(() => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return false;
    }
  }, []);
  return /*#__PURE__*/_jsxs(MicrosoftSignInAnchor, {
    className: "microsoft-sign-in",
    onClick: onClick,
    target: isIFramed ? '_blank' : '_self',
    children: [/*#__PURE__*/_jsx(UIImage, {
      src: Image.microsoftLogo
    }), /*#__PURE__*/_jsx(ButtonText, {
      smartLogin: smartLogin,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.form.microsoft"
      })
    })]
  });
};